import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import PublicWrapper from 'shared/components/layout/PublicWrapper';

const FAQ = () => {
  const { t } = useTranslation();
  return (
    <PublicWrapper>
      <div className='border-bottom flex-fill contact-page mt-md-8'>
        <div className='container'>
          <div className='d-flex flex-wrap'>
            <div className='col-md col-12 py-10 py-md-15 pb-20 pr-0 pr-md-16 pl-0'>
              <h2 className='mb-10'>{t('faq_title')}</h2>
              <p>
                <Trans i18nKey='faq_desc' />
              </p>
            </div>
            <div className='col-md col-12 contact-info py-10 pb-38 py-md-15 px-0 px-md-15' />
          </div>
        </div>
      </div>
    </PublicWrapper>
  );
};

export default FAQ;
